<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'

import { FORM, SPECKLE, useDrawerStore } from '@/stores/drawer'
const drawerStore = useDrawerStore()

const { currentCalculationDrawer, drawer } = storeToRefs(drawerStore)

const rail = ref(true)

const isActive = (drawerName: string) => currentCalculationDrawer.value === drawerName && drawer.value?.shown
</script>

<template>
  <v-navigation-drawer class="py-0" width="60" v-model="rail" :elevation="0">
    <v-list class="py-0">
      <v-list-item
        prepend-icon="mdi-file-edit"
        @click="drawerStore.toggleCalculationDrawer(FORM)"
        :active="isActive(FORM)"
        color="primary"
      ></v-list-item>
      <v-list-item
        @click.stop="drawerStore.toggleCalculationDrawer(SPECKLE)"
        :active="isActive(SPECKLE)"
        color="primary"
      >
        <v-icon size="x-large" icon="custom:speckleLogoIcon"></v-icon>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
